/**
 * Return zero as a number.
 *
 * @returns Zero as a number.
 */
export function zero() {
  return 0;
}
